import type { IPriceProductField } from '../types';

import { useCallback, useState } from 'react';

interface IPriceProductBroadcast {
  baseIDs: string[];
  field: IPriceProductField;
}

export interface IUsePriceProductBroadcastResult {
  /** Focusing the product row's own field starts one of these, naming every variant field it would
   * overwrite — what the variant rows read to draw themselves as that field's target. */
  handleBroadcastFocus: (broadcast: IPriceProductBroadcast) => void;
  handleBroadcastBlur: () => void;
  isBroadcastTarget: (params: { baseID: string; field: IPriceProductField }) => boolean;
}

export const usePriceProductBroadcast = (): IUsePriceProductBroadcastResult => {
  const [broadcast, setBroadcast] = useState<IPriceProductBroadcast | null>(null);

  const handleBroadcastFocus = useCallback(
    (next: IPriceProductBroadcast) => setBroadcast(next),
    [],
  );

  const handleBroadcastBlur = useCallback(() => setBroadcast(null), []);

  const isBroadcastTarget = useCallback(
    ({ baseID, field }: { baseID: string; field: IPriceProductField }) =>
      !!broadcast && broadcast.field === field && broadcast.baseIDs.includes(baseID),
    [broadcast],
  );

  return { handleBroadcastFocus, handleBroadcastBlur, isBroadcastTarget };
};
